import React from 'react'
import './style.css'

export default React.createClass({
  render() {
    return <div className="home">
        <h1>Slash Gaming</h1>
    </div>
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/home/index.jsx
 **/